const state = {
  userInfo: {},
  baseEnterprise: {},
}

const mutations = {
  UPDATE_USER: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ENTERPRISE: (state, data) => {
    state.baseEnterprise = data
  },
}

const actions = {
  updateUser({ commit }, userInfo) {
    commit('UPDATE_USER', userInfo)
  },
  setEnterprise({ commit }, data) {
    commit('SET_ENTERPRISE', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
